import { CSSProperties, useLayoutEffect, useRef, useState } from "react";

export function useAutoHeight(expanded: boolean, duration = 300) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => {
      setHeight(el.scrollHeight);
    };

    update();

    const observer = new ResizeObserver(update);
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return {
    ref,
    style: {
      height: expanded ? height : 0,
      overflow: "hidden",
      transition: `height ${duration}ms cubic-bezier(0.4, 0, 0.2, 1)`,
    } as CSSProperties,
  };
}
